/* Pistacho — o motor do desenho de cotas.

   Vive à parte porque é usado em dois sítios: na ficha nova (as peças com
   `templateSuffix` 2, hoje os candeeiros) e na ficha que continua no ar para os
   móveis. Uma peça não pode ser desenhada de duas maneiras consoante o endereço
   por onde se lá chega — e duas cópias do mesmo desenho divergem à primeira
   correção.

   Duas armadilhas do catálogo real, ambas tratadas aqui:

     - metade das peças está escrita em cm e a outra metade em mm;
     - "42.3" não é quarenta e dois mil e trezentos.

   Sem tratar as duas, um candeeiro de 42 cm sai do tamanho de uma moeda ao lado
   de uma porta de dois metros.

   O DESENHO (reescrito em 2026-09-09, aprovado pelo Pedro). Antes eram quatro
   vistas em fila — alçado, perfil, planta e porta — e três coisas estavam mal:

     1. O tipo era uma fracção da folha (`n * W/1460`), e não uma medida do
        ecrã: o que se lia num telemóvel eram 3,9px. Era por isso que a secção
        se escondia abaixo de 900px, e é a razão de existir o `u(px)` de agora,
        que devolve unidades de utilizador para render exactamente esses pixeis.

     2. O perfil não dizia nada. O desenho é de ENVOLVENTES, não de formas: o
        perfil (P×A) não traz um número que o alçado (L×A) e a planta (L×P) já
        não dêem. Fora ele, e com cada medida cotada uma vez em vez de duas, a
        folha do ISLET passou de 11 500 mm de largura para 4 330 — e é isso que
        a faz caber num telemóvel.

     3. Metade do catálogo não desenhava nada. O desenho exigia altura, largura
        E profundidade, e um candeeiro não tem profundidade: 56 de 143 peças
        ficavam sem desenho. Agora há famílias — A+Ø desenha-se com um círculo
        em planta, porque o `Ø` DIZ que é redondo e não se está a supor forma
        nenhuma; A+C+L desenha a envolvente.

   O que nunca se faz aqui: adivinhar. Não se desenha um tecto por cima de um
   candeeiro de suspensão, porque no A+C+L o `A` é o corpo do candeeiro nuns
   (o BRONZO tem 25 cm) e a queda total noutros (o CORONA tem 220), e isso não
   se decide por conta própria. E não se escreve uma razão de escala ("1:20"),
   que mente assim que a página muda de largura ou o leitor faz zoom: desenha-se
   uma escala gráfica, que se mede contra o próprio desenho.

   As cores e a letra vêm do sítio onde o desenho é posto, por variáveis CSS
   (`--pst-tinta`, `--pst-texto`, `--pst-cota`, `--pst-fraca`, `--pst-letra`). Nada de paleta
   escrita aqui: a mesma folha serve a página clara dos móveis e a página de
   noite dos candeeiros. */

(function () {
  'use strict';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  /* ---- medidas -------------------------------------------------------- */

  // O C dizia "Módulo com braço", que vinha do ISLET. Mas no ISLET o módulo
  // está na CAUDA da string, depois do `·`, e a cauda nunca é lida como medida:
  // o C só aparece na cabeça de 14 peças, todas candeeiros de suspensão, e em
  // zero móveis. Ou seja, o rótulo nunca esteve certo onde é usado — mostrava
  // "Módulo com braço: 1 200 mm" num candeeiro. Confirmado pelo Pedro a
  // 2026-09-09.
  // As palavras vêm na língua da página: um bloco JSON com data-pistacho-t
  // (sections/pdp-2.liquid, snippets/pistacho-medidas.liquid) trá-las dos
  // locales. O desenho não traz frases suas.
  var T = {};
  try { var elT = document.querySelector('script[data-pistacho-t]'); if (elT) T = JSON.parse(elT.textContent) || {}; } catch (e) { T = {}; }
  function tr(k, v) {
    var s = T[k] || '';
    if (v) Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(v[n]); });
    return s;
  }
  var ROTULOS = { A: tr('rot_a'), L: tr('rot_l'), P: tr('rot_p'), C: tr('rot_c'), E: tr('rot_e'), 'Ø': tr('rot_d') };

  function lerMedidas(txt) {
    var d = {};
    if (!txt) return d;
    // A string começa sempre pelas medidas gerais e só depois traz os detalhes,
    // separados por "·": o pufe do ISLET, a consola do HAVEN, o tampo da BELLE.
    // Sem cortar aí, o "Pufe 1000 × 1000 × A 450" passava a ser a altura da
    // peça. E dentro da cabeça vale a PRIMEIRA ocorrência de cada letra: nas
    // camas, "cabeceira A 1000 ...; cama A 300 ..." dava 300 de altura.
    var cabeca = String(txt).split('·')[0];
    var escala = /\bcm\b/.test(cabeca) ? 10 : 1;
    // O `\b` do JavaScript conta apenas letras ASCII, e o Ø não é uma delas.
    // Vindo sempre depois de um espaço ou de um `×` — os dois também
    // não-palavra — `\bØ` nunca casava, e 39 peças perdiam o diâmetro em
    // silêncio: um candeeiro redondo ficava só com a altura. Escapou ao
    // levantamento porque foi feito em Python, cujo `\b` é unicode e casa. A
    // fronteira passa a ser escrita à mão, com `\p{L}` para que uma letra
    // acentuada continue a contar como letra.
    var rx = /(^|[^\p{L}\p{N}])([ALPCEØ])\s*([\d.,]+)/gu, m;
    while ((m = rx.exec(cabeca)) !== null) {
      if (d[m[2]] !== undefined) continue;
      var v = m[3].replace(/\s/g, '');
      var dec = /^(\d+)(?:[.,](\d{1,2}))?$/.exec(v);
      var n = dec ? parseFloat(dec[1] + (dec[2] ? '.' + dec[2] : '')) : parseFloat(v.replace(/[.,]/g, ''));
      if (!isNaN(n)) d[m[2]] = n * escala;
    }
    return d;
  }

  // A cauda da string traz os detalhes que a cabeça não pode ter: o módulo com
  // braço do ISLET, a consola do HAVEN, a altura do assento. Lê-se à parte, sem
  // se misturar com as gerais, e escreve-se tal como está escrita — não se
  // interpreta o que não é preciso interpretar.
  function lerDetalhes(txt) {
    if (!txt) return [];
    var partes = String(txt).split('·').slice(1);
    return partes.map(function (t) { return t.replace(/\s+/g, ' ').trim(); })
                 .filter(function (t) { return t && /\d/.test(t); })
                 .slice(0, 4);
  }

  // Um número nomeado dentro da cauda, quando faz falta ao desenho.
  function detalhe(txt, palavra) {
    var re = new RegExp(palavra + '[^\\d]{0,24}(\\d[\\d ]*)', 'i');
    var m = re.exec(String(txt || ''));
    if (!m) return null;
    var n = parseFloat(m[1].replace(/\s/g, ''));
    return isNaN(n) ? null : n;
  }

  // Num desenho tecnico os milhares separam-se sempre: 3 530, nao 3530.
  function mm(v) {
    return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  /* Largura aproximada de uma linha de texto, para lhe reservar sítio. Sem isto
     o rótulo "PORTA 800 × 2000" saía fora da folha e era cortado a meio. */
  function largTexto(t, px, ls) {
    return String(t).length * px * 0.6 + Math.max(0, String(t).length - 1) * (ls || 0);
  }
  function mm(v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function n1(v) { return (+v).toFixed(1); }

  /* ---- que peça é esta ------------------------------------------------- */

  /* Não há uma peça só. Há um sofá com três medidas, um candeeiro redondo com
     duas, e uma barra suspensa com três outras. Cada família tem as vistas que
     os seus números sustentam — e nenhuma tem vistas a mais. */
  function familia(d) {
    var O = d['Ø'];
    if (d.A && d.L && d.P) return 'mob';
    if (d.A && d.C && d.L) return 'linear';
    if (d.A && d.L && O)   return 'linear';
    if (d.A && O)          return 'redondo';
    if (O && d.P)          return 'aplique';
    if (d.L && O)          return 'barra';
    return null;
  }

  /* Cada vista é uma caixa em milímetros com as cotas que lhe pertencem. Uma
     medida coteia-se UMA vez: o L está no alçado, o P na planta. Estava o L
     cotado duas vezes, e repetir uma cota num desenho é dizer duas vezes a
     mesma coisa em voz alta. */
  function vistas(d, fam, txt) {
    var O = d['Ø'], v = [];
    if (fam === 'mob') {
      v.push({ rot: tr('vista_frente'), w: d.L, h: d.A, chao: true,
        cotas: [{ e: 'h', a: d.L, lado: 'baixo', t: mm(d.L) },
                { e: 'v', a: d.A, lado: 'esq',   t: mm(d.A) }] });
      var cimaCotas = [{ e: 'v', a: d.P, lado: 'dir', t: mm(d.P) }];
      /* O módulo que a cauda declara — "Módulo com braço 1650" no ISLET — é uma
         medida real da peça e entra no desenho como cota a sério, num segundo
         nível por baixo da primeira. Estava a ser desenhado depois de a folha já
         estar arrumada, e por isso ninguém lhe reservava sítio: aterrava em cima
         da escala gráfica. */
      var mod = detalhe(txt, 'm[óo]dulo');
      if (mod && mod < d.L) cimaCotas.push({ e: 'h', a: mod, lado: 'baixo', t: mm(mod), nivel: 2, tracejado: true });
      v.push({ rot: tr('vista_cima'), w: d.L, h: d.P, cotas: cimaCotas });
      var ass = detalhe(txt, 'assento a');
      if (ass && ass < d.A) v[0].marca = { a: ass, t: tr('assento', { v: mm(ass) }) };
      return { v: v, porta: true };
    }
    if (fam === 'linear') {
      var C = d.C || d.L, larg = d.C ? d.L : (O || d.L);
      v.push({ rot: tr('vista_frente'), w: C, h: d.A,
        cotas: [{ e: 'h', a: C, lado: 'baixo', t: mm(C) },
                { e: 'v', a: d.A, lado: 'esq', t: mm(d.A) }] });
      if (larg) v.push({ rot: tr('vista_cima'), w: C, h: larg,
        cotas: [{ e: 'v', a: larg, lado: 'dir', t: mm(larg) }] });
      return { v: v, porta: false };
    }
    if (fam === 'redondo') {
      v.push({ rot: tr('vista_frente'), w: O, h: d.A,
        cotas: [{ e: 'v', a: d.A, lado: 'esq', t: mm(d.A) }] });
      v.push({ rot: tr('vista_cima'), w: O, h: O, circ: true,
        cotas: [{ e: 'h', a: O, lado: 'baixo', t: 'Ø ' + mm(O) }] });
      return { v: v, porta: false };
    }
    if (fam === 'aplique') {
      v.push({ rot: tr('vista_frente'), w: O, h: O, circ: true,
        cotas: [{ e: 'h', a: O, lado: 'baixo', t: 'Ø ' + mm(O) }] });
      v.push({ rot: tr('vista_lado'), w: d.P, h: O,
        cotas: [{ e: 'h', a: d.P, lado: 'baixo', t: mm(d.P) }] });
      return { v: v, porta: false };
    }
    if (fam === 'barra') {
      v.push({ rot: tr('vista_frente'), w: d.L, h: O,
        cotas: [{ e: 'h', a: d.L, lado: 'baixo', t: mm(d.L) },
                { e: 'v', a: O, lado: 'esq', t: 'Ø ' + mm(O) }] });
      return { v: v, porta: false };
    }
    return null;
  }

  var PORTA = { rot: tr('vista_porta'), w: 800, h: 2000, ref: true, chao: true, cotas: [] };

  /* ---- o traço --------------------------------------------------------- */

  /* Um desenho técnico lê-se pela hierarquia dos traços: o contorno pesa, a
     cota é fina, a referência é mais fina ainda. Estava tudo entre 1,0 e 1,8 —
     uma gama estreita de mais para se distinguir alguma coisa. */
  var PESO = { obj: 1.5, ref: 0.9, cota: 0.7, aux: 0.7 };
  var TIPO = { cota: 11.5, rot: 11, cart: 11 };

  function motor(k) {
    /* k = milímetros por pixel do ecrã. Tudo o que é do desenho está em
       milímetros; tudo o que é de leitura (letra, folgas, setas) é declarado em
       pixeis e convertido aqui. É esta função que faz a folha ler-se igual num
       telemóvel e num monitor. */
    function u(px) { return +(px * k).toFixed(2); }

    var GAP = u(c(5)), OVER = u(c(4)), TICK = u(4.5), TXT = u(5),
        OFS = u(Math.max(c(17), TIPO.cota + 10));

    /* O sinal de corte: uma linha quebrada de ponta a ponta da peça. */
    function zigue(x, y, w) {
      var a = u(3.2), n = 6, p = ['M' + n1(x) + ' ' + n1(y)];
      for (var i = 1; i <= n; i++) p.push('L' + n1(x + w * i / n) + ' ' + n1(y + (i % 2 ? -a : a)));
      p.push('L' + n1(x + w) + ' ' + n1(y));
      return '<path class="c" d="' + p.join('') + '"/>';
    }

    function tick(x, y) {
      return 'M' + n1(x - TICK) + ' ' + n1(y + TICK) + 'L' + n1(x + TICK) + ' ' + n1(y - TICK);
    }
    function texto(x, y, t, cls, extra) {
      return '<text x="' + n1(x) + '" y="' + n1(y) + '" class="' + cls + '"' + (extra || '') + '>' + esc(t) + '</text>';
    }

    /* Cota horizontal com linhas de chamada: saem do objecto com uma folga e
       passam um pouco além da linha de cota. É o que faz uma cota parecer
       desenhada e não colada. */
    function cotaH(x1, x2, yObj, yCota, t) {
      var s = '<path class="c" d="' +
        'M' + n1(x1) + ' ' + n1(yObj + GAP) + 'V' + n1(yCota + OVER) +
        'M' + n1(x2) + ' ' + n1(yObj + GAP) + 'V' + n1(yCota + OVER) +
        'M' + n1(x1) + ' ' + n1(yCota) + 'H' + n1(x2) +
        tick(x1, yCota) + tick(x2, yCota) + '"/>';
      if (Math.abs(x1 - x2) < largTexto(t, u(TIPO.cota), u(0.2)) * 1.25) {
        return s + texto(Math.max(x1, x2) + OVER + u(5), yCota + u(TIPO.cota * 0.34), t, 'n');
      }
      return s + texto((x1 + x2) / 2, yCota - TXT, t, 'n', ' text-anchor="middle"');
    }
    function cotaV(y1, y2, xObj, xCota, t, esquerda) {
      var d = esquerda ? -1 : 1;
      var s = '<path class="c" d="' +
        'M' + n1(xObj + d * GAP) + ' ' + n1(y1) + 'H' + n1(xCota - d * OVER) +
        'M' + n1(xObj + d * GAP) + ' ' + n1(y2) + 'H' + n1(xCota - d * OVER) +
        'M' + n1(xCota) + ' ' + n1(y1) + 'V' + n1(y2) +
        tick(xCota, y1) + tick(xCota, y2) + '"/>';
      var my = (y1 + y2) / 2;
      if (Math.abs(y1 - y2) < u(TIPO.cota) * 2.2) {
        return s + texto(xCota + d * (OVER + u(5)), my + u(TIPO.cota * 0.34), t, 'n',
          esquerda ? ' text-anchor="end"' : '');
      }
      return s + texto(0, 0, t, 'n',
        ' text-anchor="middle" transform="translate(' + n1(xCota - d * TXT) + ' ' + n1(my) + ') rotate(-90)"');
    }

    /* Uma vista posta na folha: a caixa, o rótulo e as cotas que lhe pertencem. */
    function porVista(vi, x, y) {
      var o = [], cls = vi.ref ? 'r' : 'o';
      if (vi.circ) {
        var cx = x + vi.w / 2, cy = y + vi.h / 2, r = vi.w / 2;
        o.push('<circle cx="' + n1(cx) + '" cy="' + n1(cy) + '" r="' + n1(r) + '" class="' + cls + '"/>');
        o.push('<path class="a" d="M' + n1(cx - r - GAP) + ' ' + n1(cy) + 'H' + n1(cx + r + GAP) +
               'M' + n1(cx) + ' ' + n1(cy - r - GAP) + 'V' + n1(cy + r + GAP) + '"/>');
      } else if (vi.corte) {
        /* Um candeeiro de pé tem doze centímetros de diâmetro e um metro e meio
           de altura. Desenhado inteiro é um risco de mil e quinhentos pixeis, e
           a cota não tem onde caber ao lado dele. É o caso para que existe a
           linha de corte: desenha-se o cimo e o fundo, tira-se o meio, e a cota
           continua a dizer a medida verdadeira. É convenção de desenho técnico,
           não é encolher a peça — o número não muda. */
        var hc = vi.h * 0.40, gc = vi.h * 0.20, yb = y + hc + gc;
        o.push('<path class="' + cls + '" d="M' + n1(x) + ' ' + n1(y + hc) + 'V' + n1(y) + 'H' + n1(x + vi.w) + 'V' + n1(y + hc) + '"/>');
        o.push('<path class="' + cls + '" d="M' + n1(x) + ' ' + n1(yb) + 'V' + n1(y + vi.h) + 'H' + n1(x + vi.w) + 'V' + n1(yb) + '"/>');
        o.push(zigue(x, y + hc, vi.w));
        o.push(zigue(x, yb, vi.w));
      } else {
        o.push('<rect x="' + n1(x) + '" y="' + n1(y) + '" width="' + n1(vi.w) + '" height="' + n1(vi.h) + '" class="' + cls + '"/>');
      }
      o.push(texto(x, y - u(8), LEVE ? frase(vi.rot) : vi.rot, vi.ref ? 'lr' : 'l'));
      if (vi.marca) {
        var ym = y + vi.h - vi.marca.a;
        o.push('<path class="a d" d="M' + n1(x) + ' ' + n1(ym) + 'H' + n1(x + vi.w) + '"/>');
        o.push(texto(x + GAP, ym - u(4), vi.marca.t, 'n'));
      }
      vi.cotas.forEach(function (c) {
        if (c.tracejado) o.push('<path class="a d" d="M' + n1(x + c.a) + ' ' + n1(y) + 'V' + n1(y + vi.h) + '"/>');
        if (c.e === 'h') o.push(cotaH(x, x + c.a, y + vi.h, y + vi.h + OFS * (c.nivel || 1), c.t));
        else if (c.lado === 'esq') o.push(cotaV(y + vi.h, y + vi.h - c.a, x, x - OFS, c.t, true));
        else o.push(cotaV(y + vi.h, y + vi.h - c.a, x + vi.w, x + vi.w + OFS, c.t, false));
      });
      return o.join('');
    }

    /* Espaço que a vista precisa à volta para as suas cotas caberem. */
    function folga(vi) {
      var f = { esq: 0, dir: 0, baixo: 0, cima: u(TIPO.rot + 9) };
      vi.cotas.forEach(function (c) {
        var lt = largTexto(c.t, u(TIPO.cota), u(0.2));
        if (c.e === 'h') {
          f.baixo = Math.max(f.baixo, OFS * (c.nivel || 1) + u(TIPO.cota + 5));
          if (c.a < lt * 1.25) f.dir = Math.max(f.dir, (c.a - vi.w) + OVER + u(5) + lt);
        } else if (c.a < u(TIPO.cota) * 2.2) {
          var fora = OFS + OVER + u(5) + lt;
          if (c.lado === 'esq') f.esq = Math.max(f.esq, fora); else f.dir = Math.max(f.dir, fora);
        } else if (c.lado === 'esq') f.esq = Math.max(f.esq, OFS + u(TIPO.cota + 9));
        else f.dir = Math.max(f.dir, OFS + u(TIPO.cota + 9));
      });
      if (vi.circ) { f.esq = Math.max(f.esq, GAP); f.dir = Math.max(f.dir, GAP); }
      var lr = largTexto(vi.rot, u(TIPO.rot), u(1.1)) - vi.w;
      if (lr > 0) f.dir = Math.max(f.dir, lr + u(4));
      return f;
    }

    return { u: u, porVista: porVista, folga: folga, cotaH: cotaH, cotaV: cotaV, texto: texto, GAP: GAP, OFS: OFS };
  }

  /* ---- escala gráfica --------------------------------------------------- */

  /* Uma razão escrita ("1:20") mente assim que a página muda de largura ou o
     leitor faz zoom. Uma escala gráfica não: mede-se contra o próprio desenho e
     sobrevive a qualquer reprodução. É por isso que os desenhos de arquitectura
     a trazem, e é a referência que os candeeiros passam a ter no lugar da porta
     — uma porta ao lado de um candeeiro de mesa não quer dizer nada. */
  var PASSOS = [50, 100, 200, 250, 500, 1000, 2000];
  function escolherEscala(larguraMM) {
    var alvo = larguraMM * 0.30, p = PASSOS[0];
    for (var i = 0; i < PASSOS.length; i++) if (PASSOS[i] <= alvo) p = PASSOS[i];
    return p;
  }

  /* ---- a folha ---------------------------------------------------------- */

  /* As folgas são declaradas em pixeis do ecrã. Num telemóvel a mesma folga
     come metade da folha, por isso aperta-se — mas nunca o tipo, que tem um
     mínimo de leitura e não negoceia. */
  var MARG = { esq: 16, dir: 16, cima: 12, baixo: 18 };
  var COMP = 1;
  function c(px) { return px * COMP; }
  var CART = 30;
  var GAPCART = 16;   // a faixa de baixo: escala gráfica à esquerda, legenda à direita

  /* O traço leve (29-09-2026). O Pedro, sobre o esquema na ficha nova: "aqueles
     retângulos […] em caixas cinzentas é bué feio". A ficha nova pede-o com
     `leve: true`: contorno fino, rótulos em minúsculas e sem espaçamento, sem o
     fio da legenda por cima da escala. A ficha antiga não o pede e fica igual. */
  var LEVE = false;
  function frase(t) { t = String(t || ''); return t.charAt(0) + t.slice(1).toLowerCase(); }

  function desenhar(d, txt, opts) {
    opts = opts || {};
    LEVE = !!opts.leve;
    var larguraPx = Math.max(240, opts.larguraPx || 1000);
    // A arrumação aprovada: a planta directamente por baixo do alçado, com a
    // mesma largura e ligada a ele por linhas de projecção. É o que faz duas
    // caixas soltas passarem a ser duas vistas da mesma peça.
    var layout = opts.layout || 'projecao';
    var fam = familia(d);
    if (!fam) return null;
    var esp = vistas(d, fam, txt);
    if (!esp || !esp.v.length) return null;

    var lista = esp.v.slice();
    if (esp.porta && opts.porta !== false) lista.push({ rot: PORTA.rot, w: PORTA.w, h: PORTA.h, ref: true, chao: true, cotas: [] });

    var RACIO = 3;
    lista.forEach(function (vi) {
      if (vi.circ || vi.h <= vi.w * RACIO) return;
      var hDes = vi.w * RACIO, f = hDes / vi.h;
      vi.cotas.forEach(function (c) { if (c.e === 'v') c.a *= f; });
      if (vi.marca) vi.marca.a *= f;
      vi.corte = true;
      vi.h = hDes;
    });
    if (layout === 'vista') {
      var só = lista[Math.min(opts.vista || 0, lista.length - 1)];
      lista = [só];
    }

    COMP = larguraPx < 620 ? 0.66 : 1;

    /* A largura da folha depende das folgas, e as folgas dependem de k, que
       depende da largura da folha. Resolve-se iterando: converge em duas voltas.

       Depois há um segundo travão. Uma peça alta e estreita — o CORONA tem
       2,20 m de queda e 1,20 m de vão — desenhada a ocupar toda a largura fica
       com dois mil pixeis de altura, e a secção passa a ser uma torre no meio da
       ficha. Quando isso acontece, o desenho encolhe até caber no orçamento de
       altura e centra-se na folha, como uma prancha estreita numa mesa larga.
       O tipo é recalculado para a largura real, e por isso continua nos 11,5px. */
    var alturaMax = opts.alturaMaxPx || (larguraPx < 620 ? 440 : 480);
    var render = larguraPx, k = 8, plano = null;
    for (var volta = 0; volta < 4; volta++) {
      for (var it = 0; it < 10; it++) {
        plano = arrumar(lista, layout, render, k, fam);
        var kNovo = plano.W / render;
        if (Math.abs(kNovo - k) < 0.002) { k = kNovo; break; }
        k = kNovo;
      }
      var alt = render * plano.H / plano.W;
      if (alt <= alturaMax + 0.5) break;
      render = Math.max(150, render * alturaMax / alt);
      k = plano.W / render;
    }
    plano = arrumar(lista, layout, render, k, fam);

    var M = motor(k);
    var o = [];
    plano.postas.forEach(function (p) { o.push(M.porVista(p.vi, p.x, p.y)); });

    /* A linha de chão é do alçado e da porta — quem assenta no chão. A planta
       não assenta em nada: pô-la na mesma linha, como estava, era dizer que o
       contorno de cima é o chão. */
    var chao = plano.postas.filter(function (p) { return p.vi.chao; });
    if (chao.length) {
      var y = chao[0].y + chao[0].vi.h;
      var x1 = Math.min.apply(null, chao.map(function (p) { return p.x; })) - M.u(10);
      var x2 = Math.max.apply(null, chao.map(function (p) { return p.x + p.vi.w; })) + M.u(10);
      o.unshift('<path class="ch" d="M' + n1(x1) + ' ' + n1(y) + 'H' + n1(x2) + '"/>');
    }

    /* Linhas de projecção: a planta está por baixo do alçado e as duas partilham
       a largura. São elas que fazem duas caixas soltas passarem a ser duas
       vistas da mesma peça. */
    if (layout === 'projecao' && plano.postas.length > 1) {
      var a = plano.postas[0], b = plano.postas[1];
      if (Math.abs(a.x - b.x) < 1 && Math.abs(a.vi.w - b.vi.w) < 1) {
        o.unshift('<path class="pr" d="M' + n1(a.x) + ' ' + n1(a.y + a.vi.h) + 'V' + n1(b.y) +
          'M' + n1(a.x + a.vi.w) + ' ' + n1(a.y + a.vi.h) + 'V' + n1(b.y) + '"/>');
      }
    }


    /* A faixa de baixo. */
    var yc = plano.H - (c(MARG.baixo) + CART) * k;
    if (!LEVE) o.push('<path class="pr" d="M' + n1(c(MARG.esq) * k) + ' ' + n1(yc) + 'H' + n1(plano.W - c(MARG.dir) * k) + '"/>');

    var passo = escolherEscala(plano.W);
    o.push(escalaGrafica(c(MARG.esq) * k, yc + M.u(17), passo, M, k));

    var descr = descrever(d, fam, esp);
    var id = 'pcot' + (++SERIE) + '-' + Math.random().toString(36).slice(2, 7);
    return '<svg xmlns="http://www.w3.org/2000/svg" id="' + id + '" viewBox="0 0 ' + n1(plano.W) + ' ' + n1(plano.H) +
      '" role="img" aria-label="' + esc(descr) + '" style="display:block;height:auto;margin-inline:auto;width:' +
      Math.round(render) + 'px;max-width:100%">' + estilo(k, id) + o.join('') + '</svg>';
  }

  /* Arrumar as vistas na folha. */
  function arrumar(lista, layout, larguraPx, k, fam) {
    var M = motor(k);
    var folgas = lista.map(M.folga);
    var GAPV = M.u(c(42));
    var postas = [], W, H;

    function medir() {
      var x1 = Infinity, y1 = Infinity, x2 = -Infinity, y2 = -Infinity;
      postas.forEach(function (p, i) {
        var f = folgas[lista.indexOf(p.vi)] || folgas[i];
        x1 = Math.min(x1, p.x - f.esq); x2 = Math.max(x2, p.x + p.vi.w + f.dir);
        y1 = Math.min(y1, p.y - f.cima); y2 = Math.max(y2, p.y + p.vi.h + f.baixo);
      });
      return { x1: x1, y1: y1, x2: x2, y2: y2 };
    }

    function vao(iCima, iBaixo) {
      return Math.max(GAPV, folgas[iCima].baixo + folgas[iBaixo].cima + M.u(c(8)));
    }

    if (layout === 'projecao' && lista.length > 1) {
      /* Alçado em cima; planta directamente por baixo, encostada à mesma
         esquerda; a porta à direita, na linha de chão do alçado. */
      var alc = lista[0], pla = lista[1], porta = lista[2];
      var hTopo = porta ? Math.max(alc.h, porta.h) : alc.h;
      postas.push({ vi: alc, x: 0, y: hTopo - alc.h });
      if (porta) postas.push({ vi: porta, x: alc.w + GAPV + folgas[0].dir + folgas[2].esq, y: hTopo - porta.h });
      postas.push({ vi: pla, x: 0, y: hTopo + vao(0, 1) });
    } else if (layout === 'vista' || lista.length === 1) {
      postas.push({ vi: lista[0], x: 0, y: 0 });
    } else {
      /* Prancha: tudo numa linha, assente na mesma base. Num ecrã estreito não
         cabe, e então parte-se em duas — a peça e a porta em cima, a planta por
         baixo. Continua a ser a mesma escala; muda só a arrumação. */
      var estreito = larguraPx < 620;
      if (estreito && lista.length > 2) {
        var h1 = Math.max(lista[0].h, lista[2].h);
        postas.push({ vi: lista[0], x: 0, y: h1 - lista[0].h });
        postas.push({ vi: lista[2], x: lista[0].w + GAPV + folgas[0].dir + folgas[2].esq, y: h1 - lista[2].h });
        postas.push({ vi: lista[1], x: 0, y: h1 + vao(0, 1) });
      } else if (estreito && lista.length === 2 && (lista[0].w + lista[1].w) > larguraPx * k * 0.8) {
        postas.push({ vi: lista[0], x: 0, y: 0 });
        postas.push({ vi: lista[1], x: 0, y: lista[0].h + vao(0, 1) });
      } else {
        var base = Math.max.apply(null, lista.map(function (v) { return v.h; }));
        var x = 0;
        lista.forEach(function (vi, i) {
          var f = folgas[i];
          if (i) x += GAPV + f.esq;
          postas.push({ vi: vi, x: x, y: base - vi.h });
          x += vi.w + f.dir;
        });
      }
    }

    var b = medir();
    var dx = c(MARG.esq) * k - b.x1, dy = c(MARG.cima) * k - b.y1;
    postas.forEach(function (p) { p.x += dx; p.y += dy; });
    W = (b.x2 - b.x1) + c(MARG.esq + MARG.dir) * k;
    H = (b.y2 - b.y1) + (c(MARG.cima + GAPCART + MARG.baixo) + CART) * k;
    return { postas: postas, W: W, H: H };
  }

  function escalaGrafica(x, y, passo, M, k) {
    var o = [], h = M.u(4.5), n = 4, seg = passo / n;
    for (var i = 0; i < n; i++) {
      o.push('<rect x="' + n1(x + i * seg) + '" y="' + n1(y - h) + '" width="' + n1(seg) + '" height="' + n1(h) +
        '" class="' + (i % 2 ? 'eb' : 'ea') + '"/>');
    }
    o.push('<path class="c" d="M' + n1(x) + ' ' + n1(y - h) + 'H' + n1(x + passo) + 'V' + n1(y) + 'H' + n1(x) + 'Z"/>');
    o.push(M.texto(x, y + M.u(TIPO.cart + 2), '0', 'cart'));
    o.push(M.texto(x + passo, y + M.u(TIPO.cart + 2), mm(passo) + ' mm', 'cart', ' text-anchor="middle"'));
    return o.join('');
  }

  function descrever(d, fam, esp) {
    var p = [];
    if (d.L) p.push(tr('desc_largura', { v: mm(d.L) }));
    if (d.C) p.push(tr('desc_comprimento', { v: mm(d.C) }));
    if (d.A) p.push(tr('desc_altura', { v: mm(d.A) }));
    if (d.P) p.push(tr('desc_profundidade', { v: mm(d.P) }));
    if (d['Ø']) p.push(tr('desc_diametro', { v: mm(d['Ø']) }));
    return tr('desc', { lista: p.join(', ') }) + (esp.porta ? tr('desc_porta') : '.');
  }

  /* A letra e a cor não são escritas aqui: vêm do sítio onde o desenho é posto.
     A `font-family` é declarada sempre — o corpo do tema resolve para Times, e
     um desenho técnico com números em serifa está errado antes de se ler.

     As cores obedecem a uma regra, medida e não estimada: o que é TEXTO tem de
     ter 4,5 de contraste contra o papel, e o que é GRÁFICO e carrega significado
     — o contorno da porta — tem de ter 3. O dourado da cota media 3,47 contra o
     papel claro: chega para a linha, não chega para o número. Por isso os
     números passaram do dourado para a tinta (`--pst-texto`), e as linhas de
     cota ficaram douradas — que também arruma melhor a hierarquia, porque o
     número é informação e a linha é estrutura. O rótulo da porta media 1,46 no
     claro e 1,92 no escuro: era um rótulo que não se lia em nenhuma das duas.

     A linha tracejada do módulo e as linhas de projecção mediam 1,46: também
     não são decoração. A tracejada diz ONDE está o módulo que a cota nomeia, e
     sem ela o número mede o nada; as de projecção são o que faz duas caixas
     soltas passarem a ser duas vistas da mesma peça. Sobem para o mesmo cinzento
     do contorno da porta — continuam muito abaixo do traço do objecto, que é o
     que manda. */
  var SERIE = 0;
  function estilo(k, id) {
    function w(px) { return +(px * k).toFixed(2); }
    var q = '#' + id + ' ';
    if (LEVE) {
      return '<style>' +
        q + 'text{font-family:var(--pst-letra,"Inter",system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif);' +
        'font-variant-numeric:tabular-nums;fill:var(--pst-texto,#4f4a3f)}' +
        q + '.o{fill:none;stroke:var(--pst-tinta,#14130e);stroke-width:' + w(0.9) + ';stroke-linejoin:miter}' +
        q + '.r{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(0.75) + ';stroke-dasharray:' + w(4) + ' ' + w(3) + '}' +
        q + '.c{fill:none;stroke:var(--pst-cota,#8a7c5f);stroke-width:' + w(0.7) + ';stroke-linecap:round}' +
        q + '.a{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(0.6) + '}' +
        q + '.d{stroke-dasharray:' + w(4) + ' ' + w(3) + '}' +
        q + '.ch{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(0.75) + '}' +
        q + '.pr{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(0.6) + '}' +
        q + '.ea{fill:var(--pst-cota,#8a7c5f)}' + q + '.eb{fill:none}' +
        q + '.n{font-size:' + w(TIPO.cota) + 'px}' +
        q + '.l,' + q + '.lr{font-size:' + w(12) + 'px;fill:var(--pst-texto,#4f4a3f)}' +
        q + '.cart{font-size:' + w(TIPO.cart) + 'px;fill:var(--pst-texto,#4f4a3f)}' +
        '</style>';
    }
    return '<style>' +
      q + 'text{font-family:var(--pst-letra,"Inter",system-ui,-apple-system,"Helvetica Neue",Arial,sans-serif);' +
      'font-variant-numeric:tabular-nums;fill:var(--pst-texto,#4f4a3f)}' +
      q + '.o{fill:none;stroke:var(--pst-tinta,#14130e);stroke-width:' + w(PESO.obj) + ';stroke-linejoin:miter}' +
      q + '.r{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(PESO.ref) + '}' +
      q + '.c{fill:none;stroke:var(--pst-cota,#8a7c5f);stroke-width:' + w(PESO.cota) + ';stroke-linecap:round}' +
      q + '.a{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(PESO.aux) + '}' +
      q + '.d{stroke-dasharray:' + w(5) + ' ' + w(4) + '}' +
      q + '.ch{fill:none;stroke:var(--pst-tinta,#14130e);stroke-width:' + w(PESO.obj) + '}' +
      q + '.pr{fill:none;stroke:var(--pst-fraca,#8f8b80);stroke-width:' + w(0.7) + '}' +
      q + '.ea{fill:var(--pst-cota,#8a7c5f)}' + q + '.eb{fill:none}' +
      q + '.n{font-size:' + w(TIPO.cota) + 'px;letter-spacing:' + w(0.2) + 'px}' +
      q + '.l{font-size:' + w(TIPO.rot) + 'px;letter-spacing:' + w(1.1) + 'px;fill:var(--pst-tinta,#14130e)}' +
      q + '.lr{font-size:' + w(TIPO.rot) + 'px;letter-spacing:' + w(1.1) + 'px;fill:var(--pst-texto,#4f4a3f)}' +
      q + '.cart{font-size:' + w(TIPO.cart) + 'px;letter-spacing:' + w(1) + 'px;fill:var(--pst-texto,#4f4a3f)}' +
      '</style>';
  }

  /* ---- os desenhos da própria peça ------------------------------------------

     29-09-2026. O esquema acima é só a envolvente: um retângulo por vista. Para
     as peças que já têm vistas em linha tiradas do modelo da marcenaria (piloto:
     ESCAPE 3 lugares), a ficha nova mostra-as a elas, e as cotas são desenhadas
     aqui por cima, em pixeis do ecrã, com a letra da página.

     De onde vêm: metafield `custom.cad_desenhos` (JSON) — uma lista de vistas,
     cada uma com o URL de um SVG em Shopify Files cujo viewBox está em
     MILÍMETROS e que traz só traço: `<path class="o">` (contorno) e
     `<path class="a">` (projectado, a tracejado). Os números que se escrevem
     (L, P, A) vêm da cabeça de `custom.medidas`, não do viewBox: a altura do
     ESCAPE é 866,64 no modelo e publica-se 866 — arredondar o viewBox dava 867.

     O SVG que vem de fora nunca entra na página tal como veio. Lê-se com o
     DOMParser, guardam-se só os atributos `d` que sejam comandos de caminho e
     números, e o desenho é reescrito aqui. */

  var CAD_CACHE = {};
  var RX_D = /^[MLHVZmlhvz0-9.,\s-]+$/;

  function cadLer(url) {
    if (CAD_CACHE[url]) return CAD_CACHE[url];
    CAD_CACHE[url] = fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('cad ' + r.status);
      return r.text();
    }).then(function (txt) {
      var doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
      var svg = doc.documentElement;
      if (!svg || svg.nodeName.toLowerCase() !== 'svg') throw new Error('cad: não é svg');
      var vb = String(svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
      if (vb.length !== 4 || vb.some(isNaN) || vb[2] <= 0 || vb[3] <= 0) throw new Error('cad: viewBox');
      var geo = { x: vb[0], y: vb[1], W: vb[2], H: vb[3], o: [], a: [] };
      [].forEach.call(doc.getElementsByTagName('path'), function (p) {
        var d = p.getAttribute('d') || '';
        if (!d || !RX_D.test(d)) return;
        (p.getAttribute('class') === 'a' ? geo.a : geo.o).push(d);
      });
      if (!geo.o.length) throw new Error('cad: sem traço');
      return geo;
    });
    return CAD_CACHE[url];
  }

  var CT = 11.5;                           // o tipo das cotas, em pixeis do ecrã

  /* As folgas de cada vista, em pixeis: onde cabem as cotas. `alinhar` iguala a
     esquerda da planta à do alçado, para as duas ficarem uma por baixo da outra. */
  function cadFolgas(vista, spec) {
    var f = { l: 10, r: 10, t: 8, b: 10 };
    if (vista === 'frente') { f.l = 40; f.b = 38; }
    if (vista === 'planta') { f.l = 40; if (spec && spec.marcas && spec.marcas.length) f.b = 40; }
    if (vista === 'corte') {
      f.b = 38;
      var mx = 0;
      (spec.niveis || []).forEach(function (n) {
        mx = Math.max(mx, largTexto(mm(n.z) + '  ' + tr('nivel_' + n.k), CT, 0.1));
      });
      f.r = mx ? mx + 30 : 10;
    }
    return f;
  }

  /* Uma vista: o traço da peça escalado para `k` milímetros por pixel, e as
     cotas em pixeis. `nums` traz L, P, A já lidos de custom.medidas. */
  function cadVista(vista, spec, geo, k, nums, f) {
    var W = geo.W / k, H = geo.H / k;
    var x0 = f.l, y0 = f.t, cw = f.l + W + f.r, ch = f.t + H + f.b;
    var o = [];
    function T(x, y, t, cls, extra) {
      return '<text x="' + n1(x) + '" y="' + n1(y) + '"' + (cls ? ' class="' + cls + '"' : '') + (extra || '') + '>' + t + '</text>';
    }
    function tk(x, y) { return 'M' + n1(x - 3.5) + ' ' + n1(y + 3.5) + 'L' + n1(x + 3.5) + ' ' + n1(y - 3.5); }
    function cotaH(x1, x2, yObj, y, t) {
      return '<path class="k" d="M' + n1(x1) + ' ' + n1(yObj + 4) + 'V' + n1(y + 4) + 'M' + n1(x2) + ' ' + n1(yObj + 4) + 'V' + n1(y + 4) +
        'M' + n1(x1) + ' ' + n1(y) + 'H' + n1(x2) + tk(x1, y) + tk(x2, y) + '"/>' +
        T((x1 + x2) / 2, y + CT + 3, esc(t), 'n', ' text-anchor="middle"');
    }
    function cotaV(y1, y2, xObj, x, t) {
      return '<path class="k" d="M' + n1(xObj - 4) + ' ' + n1(y1) + 'H' + n1(x - 4) + 'M' + n1(xObj - 4) + ' ' + n1(y2) + 'H' + n1(x - 4) +
        'M' + n1(x) + ' ' + n1(y1) + 'V' + n1(y2) + tk(x, y1) + tk(x, y2) + '"/>' +
        T(0, 0, esc(t), 'n', ' text-anchor="middle" transform="translate(' + n1(x - 6) + ' ' + n1((y1 + y2) / 2) + ') rotate(-90)"');
    }

    /* O traço: escalado num grupo. A espessura e o tracejado escrevem-se em
       milímetros (px × k), para saírem com a mesma medida em pixeis a qualquer
       escala — o `vector-effect` resolvia a espessura mas não o tracejado. */
    var s = 1 / k, px = function (v) { return +(v * k).toFixed(3); };
    o.push('<g fill="none" stroke-linecap="round" stroke-linejoin="round" transform="translate(' + n1(x0) + ' ' + n1(y0) + ') scale(' + s.toFixed(6) + ') translate(' + (-geo.x) + ' ' + (-geo.y) + ')">' +
      (geo.a.length ? '<g class="ga" stroke-width="' + px(0.7) + '" stroke-dasharray="' + px(4) + ' ' + px(3) + '">' +
        geo.a.map(function (d) { return '<path d="' + esc(d) + '"/>'; }).join('') + '</g>' : '') +
      '<g class="go" stroke-width="' + px(0.8) + '">' +
        geo.o.map(function (d) { return '<path d="' + esc(d) + '"/>'; }).join('') + '</g></g>');

    if (vista === 'frente' || vista === 'corte') {
      o.push('<path class="ch" d="M' + n1(x0 - 8) + ' ' + n1(y0 + H) + 'H' + n1(x0 + W + 8) + '"/>');
    }
    if (vista === 'frente') {
      if (nums.L) o.push(cotaH(x0, x0 + W, y0 + H, y0 + H + 18, mm(nums.L)));
      if (nums.A) o.push(cotaV(y0 + H, y0, x0, x0 - 18, mm(nums.A)));
    }
    if (vista === 'corte') {
      if (nums.P) o.push(cotaH(x0, x0 + W, y0 + H, y0 + H + 18, mm(nums.P)));
      /* Os níveis: uma guia muito fraca de lado a lado e o número à direita.
         Rótulos que ficassem a menos de 14px uns dos outros afastam-se. */
      var ult = Infinity;
      (spec.niveis || []).slice().sort(function (a, b) { return a.z - b.z; }).forEach(function (n) {
        var y = y0 + H - n.z / k, yt = Math.min(y + CT * 0.35, ult - 14);
        ult = yt;
        o.push('<path class="gl" d="M' + n1(x0) + ' ' + n1(y) + 'H' + n1(x0 + W + 14) + '"/>');
        o.push('<path class="k" d="M' + n1(x0 + W + 14) + ' ' + n1(y) + 'L' + n1(x0 + W + 20) + ' ' + n1(yt - CT * 0.35) + '"/>');
        o.push(T(x0 + W + 24, yt, '<tspan class="nv">' + esc(mm(n.z)) + '</tspan> ' + esc(tr('nivel_' + n.k)), 'n'));
      });
      /* O fundo útil, desenhado no plano do assento, que é onde foi medido. */
      var lv = spec.livre;
      if (lv && lv.v && lv.x2 > lv.x1) {
        var ya = y0 + H - lv.z / k, yc = ya - 11;
        var xa = x0 + (lv.x1 - geo.x) / k, xb = x0 + (lv.x2 - geo.x) / k;
        o.push('<path class="k" d="M' + n1(xa) + ' ' + n1(ya - 2) + 'V' + n1(yc - 3) + 'M' + n1(xb) + ' ' + n1(ya - 2) + 'V' + n1(yc - 3) +
          'M' + n1(xa) + ' ' + n1(yc) + 'H' + n1(xb) + tk(xa, yc) + tk(xb, yc) + '"/>');
        o.push(T((xa + xb) / 2, yc - 5, '≈ ' + esc(mm(lv.v)), 'n', ' text-anchor="middle"'));
      }
    }
    if (vista === 'planta') {
      (spec.marcas || []).forEach(function (m) {
        var cx = x0 + ((m.x1 + m.x2) / 2 - geo.x) / k, cy = y0 + ((m.y1 + m.y2) / 2 - geo.y) / k;
        var yb = y0 + H + 16;
        var t = (tr('marca_' + m.k) || '') + (m.t ? ' ' + m.t + ' mm' : '');
        var lt = largTexto(t, CT, 0.1);
        var tx = Math.max(x0, Math.min(cx - 6, cw - f.r - lt));
        o.push('<circle class="pt" cx="' + n1(cx) + '" cy="' + n1(cy) + '" r="2"/>');
        o.push('<path class="k" d="M' + n1(cx) + ' ' + n1(cy + 3) + 'V' + n1(yb) + '"/>');
        o.push(T(tx, yb + CT + 2, esc(t), 'n'));
      });
    }
    return { svg: '<svg xmlns="http://www.w3.org/2000/svg" class="pcad" viewBox="0 0 ' + n1(cw) + ' ' + n1(ch) +
      '" width="' + Math.round(cw) + '" height="' + Math.round(ch) + '" aria-hidden="true" focusable="false">' + o.join('') + '</svg>',
      w: cw, h: ch };
  }

  window.PistachoCotas = {
    cadLer: cadLer,
    cadFolgas: cadFolgas,
    cadVista: cadVista,
    ROTULOS: ROTULOS,
    ler: lerMedidas,
    detalhes: lerDetalhes,
    detalhe: detalhe,
    mm: mm,
    familia: familia,
    desenhar: desenhar
  };
}());
